module.exports = __webpack_public_path__ + "static/media/collect_word_ru.4c74b94b.jpg";